import { MouseEventHandler } from "react";
import { Portal } from "@headlessui/react";

import { useTranslation } from "../stores/RootStoreContext";

export function ShowPreviewButton({ onClick }: { onClick: MouseEventHandler<HTMLButtonElement> }) {
  const { t } = useTranslation();

  return (
    <Portal>
      <button
        style={{}}
        className={
          "tw-fixed tw-bottom-0 tw-left-2 tw-shadow-md bg-primary-light tw-px-3 tw-py-2 tw-rounded-t"
        }
        type="button"
        onClick={onClick}
      >
        {t("show.preview")}
      </button>
    </Portal>
  );
}
